import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type BlogCategoryBaseFragment = { id: string, pk: number, slug: string, name: string };

export type BlogCategoryFragment = { description: string, id: string, pk: number, slug: string, name: string, blog: { id: string, pk: number, slug: string, name: string }, image: { url: string } };

export const BlogCategoryBaseFragmentDoc = gql`
    fragment BlogCategoryBaseFragment on BlogCategoryType {
  id
  pk
  slug
  name
}
    `;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategoryFragment on BlogCategoryType {
  ...BlogCategoryBaseFragment
  blog {
    id
    pk
    slug
    name
  }
  description
  image {
    url
  }
}
    ${BlogCategoryBaseFragmentDoc}`;